import React, { useState } from 'react';
import classNames from 'classnames';
import { Visibility, VisibilityOff } from '@material-ui/icons';

import TextWidget, { TextWidgetType } from '../TextWidget/TextWidget';
import Button from 'components/UI/Buttons/Button/Button';

import styles from './PasswordWidget.module.scss';

export default function PasswordWidget(props: PasswordWidgetType): JSX.Element {
  const { children, classes, done, error } = props;
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const extraClasses = {
    ...{
      closeIcon: styles.closeIcon,
      doneIcon: styles.doneIcon,
    },
    ...classes,
  };

  function renderIcons(): JSX.Element {
    return (
      <Button
        type={'button'}
        className={classNames(styles.button, {
          [styles.passwordVisible]: isVisible,
          [styles.shift]: error || done,
        })}
        onClick={() => setIsVisible(isVisible => !isVisible)}
      >
        <Visibility className={styles.visibilityIcon} />
        <VisibilityOff className={styles.visibilityOffIcon} />
      </Button>
    );
  }

  return (
    <TextWidget
      {...props}
      classes={extraClasses}
      icons={renderIcons()}
      type={isVisible ? 'text' : 'password'}
    >
      {children}
    </TextWidget>
  );
}

type PasswordWidgetType = Omit<TextWidgetType, 'type'>;
